/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Auth, I18n, JS, Logger } from 'aws-amplify';
import React from 'react';
import { ButtonRow, InputRow, SectionBody, SectionFooter } from '../AmplifyUI';
import AuthPiece from './AuthPiece';
import { FederatedButtons } from './FederatedSignIn';
import Grid from '@material-ui/core/Grid';
import ConfirmationDialog from '../../components/ConfirmationDialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import preval from 'preval.macro'
import { logEvent } from "firebase/analytics";
 import { analytics } from "../../api/firebase";


require('./login.css');
const logger = new Logger('SignIn');
const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 300,
    },
    menu: {
        width: 300,
    },
    button: {
        margin: theme.spacing.unit,
    },
    input: {
        display: 'none',
    },
    card: {
        display: 'flex',
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 0 auto',
    },
});

class SignIn extends AuthPiece {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }
        this.params = new URLSearchParams(window.location.search);
        this.passport = this.params.get('passport');
        this.email = this.params.get('email');
        this.cpr = this.params.get('cpr');

        this.checkContact = this.checkContact.bind(this);
        this.signIn = this.signIn.bind(this);
        this.confirmSignIn = this.confirmSignIn.bind(this);
        this._validAuthStates = ['signIn', 'signedOut', 'signedUp'];
        this.state = { openConfirmWarning: false };

        if ((this.passport != '' && this.passport != null) || (this.cpr != '' && this.cpr != null)) {
            this.changeState('signUp')
        }

        logEvent(analytics, 'hcp_public_user_navigated', {
            page_name: 'login_page',
            datetime: new Date().toISOString(),
        });

    }

    checkContact(user) {
        Auth.verifiedContact(user)
            .then(data => {
                if (!JS.isEmpty(data.verified)) {
                    this.changeState('signedIn', user);
                }
                else {
                    user = Object.assign(user, data);
                    this.changeState('verifyContact', user);
                }
            });
    }

    showLoading = () => {

        return <div
            className="loader-view-block">
            <div className="loader-view">
                <CircularProgress />

            </div>
        </div>
    };

    signIn() {

        this.setState({ loading: true })
        const { username, password } = this.inputs;
        if (!username && !password) {
            this.setState({ loading: false })
            this.error('Please enter username and password');
            return;
        }
        else if (!username) {
            this.setState({ loading: false })
            this.error('Please enter username');
            return;
        } else if (!password) {
            this.setState({ loading: false })
            this.error('Please enter password');
            return;
        }
        else {
            Auth.signIn(username, password)
                .then(user => {
                    logger.debug(user);
                    if (user.challengeName === 'SMS_MFA' || user.challengeName === 'SOFTWARE_TOKEN_MFA') {
                        logger.debug('confirm user with ' + user.challengeName);
                        this.changeState('confirmSignIn', user);
                    }
                    else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                        logger.debug('require new password', user.challengeParam);
                        this.changeState('requireNewPassword', user);
                    }
                    else if (user.challengeName === 'MFA_SETUP') {
                        logger.debug('TOTP setup', user.challengeParam);
                        this.changeState('TOTPSetup', user);
                    }
                    else {
                        this.checkContact(user);
                    }
                })
                .catch(err => {
                    if (err.message && err.message.indexOf("User is not confirmed.") !== -1) {
                        this.setState({ loading: false })
                        this.setState({ openConfirmWarning: true });
                        this.error('');
                    }
                    else {
                        this.setState({ loading: false })
                        this.error(err);
                    }


                });
        }

    }

    confirmSignIn() {
        const { username } = this.inputs;
        this.changeState('confirmSignUp', username);
        this.inputs = {};
    }

    showComponent(theme) {
        const { authState, hide, federated, onStateChange } = this.props;
        if (hide && hide.includes(SignIn)) { return null; }
        return (

            <div className="flex_div">

                <div className="login-content text-center" >

                    <div className="logo_main">
                        <img src="/Mehan_logo.png" />
                    </div>
                    <div className='content'>
                        <p>Welcome to <span>"Mehan"</span> our new online professionals application system. If you are using <span>"Mehan"</span> for the first time you have to create a new account and password. Please click to Sign Up to create the account.. DO NOT  sign in ..sign up</p>
                        {/* <p className='pad_cus'>Click on <Button
                            color="secondary"
                            onClick={() => {
                                this.changeState('signUp'); this.inputs = {}; this.setState({ loading: false });
                            }}>
                            {I18n.get('Sign Up')}
                        </Button> link to create your account.</p> */}
                    </div>
                    <div className="logo-text">NATIONAL HEALTH REGULATORY AUTHORITY</div>
                    <ConfirmationDialog mode='signIn'
                        open={this.state.openConfirmWarning}
                        confirm_title={'Confirmation Required!!'}
                        confirm_message={'A confirmation code was sent on your Email address/Mobile number.You need to confirm before you can sign in.Click on \'YES\' to proceed to confirm user!'}
                        button_yes={'YES'}
                        button_no={'NO'}

                        confirmResult={(result) => {
                            this.setState({ openConfirmWarning: false });
                            if (result) {
                                this.confirmSignIn();
                            }

                        }} />
                    <div className="mt-3">
                        <Typography gutterBottom variant="headline" component="h2">
                            {I18n.get('Sign In Account')}
                        </Typography>
                    </div>
                    <Grid container spacing={16}>
                        <Grid item xs={12}>
                            <InputRow
                                required
                                label={I18n.get('Username/CPR')}
                                key="username"
                                name="username"
                                onChange={this.handleInputChange} />
                        </Grid>
                        <Grid item xs={12}>
                            <InputRow
                                required
                                label={I18n.get('Password')}
                                theme={theme}
                                key="password"
                                type="password"
                                name="password"
                                onChange={this.handleInputChange} />
                        </Grid>
                    </Grid>
                    <SectionBody>
                        {!this.state.loading && <ButtonRow theme={theme} onClick={this.signIn}>
                            {I18n.get('Sign In')}
                        </ButtonRow>}
                        <div>&nbsp;</div>
                        <FederatedButtons
                            federated={federated}
                            theme={theme}
                            authState={authState}
                            onStateChange={onStateChange}
                        />
                    </SectionBody>
                    {this.state.loading && this.showLoading()}
                    {/*<SectionFooter>*/}

                    <Grid container>
                        <Grid item xs={5} style={Object.assign({ textAlign: 'left' }, theme.col6)}>
                            <Button
                                color="secondary"
                                onClick={() => {
                                    this.changeState('forgotPassword'); this.inputs = {}; this.setState({ loading: false });
                                }}>
                                {I18n.get('Forgot Password')}
                            </Button>
                        </Grid>
                        {/* <Grid item xs={4} style={Object.assign({ textAlign: 'right' }, theme.col6)}>
                        <p className="not_reg">If Not Registered?</p>
                    </Grid> */}
                        <Grid item xs={7} style={Object.assign({ textAlign: 'right' }, theme.col6)}>
                            <div className="d_flex">
                                <span className="not_reg">If Not Registered?</span>
                                <Button
                                    color="secondary"
                                    onClick={() => {
                                        this.changeState('signUp'); this.inputs = {}; this.setState({ loading: false });
                                    }}>
                                    {I18n.get('Sign Up')}
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} style={{ fontSize: '11px', float: 'right' }}>
                            <p>
                                Build Date: {preval`module.exports = new Date().toLocaleString('en-US', { timeZone: 'Asia/Bahrain' });`}.
                            </p>
                        </Grid>
                    </Grid>
                    {/*  </SectionFooter>*/}

                </div>
            </div>
        )
    }
}

export default SignIn;
